import { useMemo } from "react";
import { useAppSelector } from "../../store/index.ts";

export default function useNickname() {
  const name = useAppSelector((state) => state.user.user.nickname) || "";

  const nickname = useMemo(() => {
    return name && !name.startsWith("@") ? "@" + name : name;
  }, [name]);

  return { name, nickname };
}
